import React from "react";
import { VeriDatePickerBodyProps } from "./VeriDatePickerBody.types";
import { useVeriDatePicker } from "../VeriDatePickerContext";
import { VeriDatePickerDaysView } from "../views/VeriDatePickerDaysView";
import { VeriDatePickerMonthsYearsView } from "../views/VeriDatePickerMonthsYearsView";
import { VeriDatePickerView } from "../VeriDatePickerContext/VeriDatePickerContext.types";

const VeriDatePickerBody: React.FC<VeriDatePickerBodyProps> = () => {
  const datePicker = useVeriDatePicker();

  switch (datePicker.view) {
    case VeriDatePickerView.YearsAndMonths:
      return <VeriDatePickerMonthsYearsView />;
  }

  return <VeriDatePickerDaysView />;
};

export default VeriDatePickerBody;
